function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.333,0H.667A.666.666,0,0,0,0,.667V23.333A.666.666,0,0,0,.667,24H23.333A.666.666,0,0,0,24,23.333V.667A.666.666,0,0,0,23.333,0Zm-.666,1.333V20H17.333v-.667a2,2,0,0,0-2-2H13.272l5.276-7.621a.666.666,0,0,0-.027-.8L15.854,5.583a.669.669,0,0,0-.521-.25H8.667a.669.669,0,0,0-.521.25L5.479,8.917a.666.666,0,0,0-.027.8l5.276,7.621H8.667a2,2,0,0,0-2,2V20H1.333V1.333ZM12.882,6.667l.8,2H10.318l.8-2ZM10.237,10h3.526L12,15.733Zm4.922,0h1.569L13.9,14.08Zm-.042-1.333-.8-2h.7l1.6,2Zm-6.234,0h-1.5l1.6-2h.7ZM8.841,10,10.1,14.08,7.272,10Zm6.492,8.667a.667.667,0,0,1,.667.666V20H8v-.667a.667.667,0,0,1,.667-.666Zm-14,4V21.333H22.667v1.334Z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/raw_collectibles.26b833de.svg";
export { SvgComponent as ReactComponent };